import React, {Component} from 'react';
import {Alert, Button, Col, Container, Input, Row} from 'reactstrap';
import Notify from 'react-notification-alert';
import {request} from "../../helper/APIUtils";
import ReactLoadingTop from '../../components/ReactLoadingTop'
import Datetime from '../../components/Datetime'
import moment from 'moment'
import SingleFileSigner from "./component/SingleFileSigner"
import ReactLoading from 'react-loading';
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import EdefterApplicationModal from "../../components/EdefterApplicationModal";
import Swal from "sweetalert2";
import {EntegratorConf, SERVLET_PATH} from "../../constants";
import {EntegratorIdentifiers} from "../../helper/enums";

var base64_arraybuffer = require('base64-arraybuffer')

class ApplicationSigner extends Component {

    constructor(props) {
        super(props);

        this.init = this.init.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.editHandleInputChange = this.editHandleInputChange.bind(this);
        this.cancelClicked = this.cancelClicked.bind(this);
        this.cancelClickedWithAlert = this.cancelClickedWithAlert.bind(this);
        this.inputOkClicked = this.inputOkClicked.bind(this);
        this.signCompleted = this.signCompleted.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.getEdefterContract = this.getEdefterContract.bind(this);
        this.checkContactPersonInfo = this.checkContactPersonInfo.bind(this);
        this.inputClicked = this.inputClicked.bind(this);
        this.applyWithSignature = this.applyWithSignature.bind(this);
        this.applyWithoutSignature = this.applyWithoutSignature.bind(this);
        this.hasSaklamaService = this.hasSaklamaService.bind(this);
        this.setYazilimUreticiList = this.setYazilimUreticiList.bind(this);

        this.state = {
            softwareListLoading: false,
            softwareList: [],
            valid: {},
            selected: {
                software: "",
                startDate: moment('2022-01-01', 'YYYY-MM-DD').add(3, "hours")
            },
            contract: null,
            edefterApplicationModal: false,
            sorumluFieldsValid: true,
            unsignedApplication: props.unsignedApplication,
            loadingUnsignedApplication: true,
            hasSaklama:null
        }

        this.editValidateDef = {
            software: v => !!v,
            startDate: v => moment.isMoment(v)
        }
    }

    componentDidMount() {
        Promise.resolve(this.hasSaklamaService())
            .then(() => {
                return this.init();
            });
    }

    init() {
        let self = this;
        let params = {
            url: '/signature/application/readEdefterSoftwareList',
            method: "get"
        };
        self.setState({
            softwareListLoading: true,
        });

        request(params)
            .then(response => {
                let filteredsoftwareList = this.setYazilimUreticiList(response.data.result);
                self.setState((state, props) => {
                    return {
                        softwareList: filteredsoftwareList,
                        selected: {
                            software: response.data.default
                        }
                    }
                }, () => self.getEdefterContract());

            }).catch(function (error) {
            showAxiosError(error);
        }).finally(() => {
            self.setState({softwareListLoading: false});
        });
    }

    setYazilimUreticiList(filteredsoftwareList) {
        const {currentUser} = this.props;
        const {hasSaklama} = this.state;
        const {identifier} = EntegratorConf;
        const {KOLAYSOFT, SMART, DEVATEK} = EntegratorIdentifiers;

        if ((identifier === KOLAYSOFT || identifier === SMART) && hasSaklama) {
            return filteredsoftwareList;
        }

        if (identifier === KOLAYSOFT && currentUser.parentCustomerId === 3956) {
            return filteredsoftwareList.filter((software) =>
                software.label.includes("PARK E-Defter V1.0")
            );
        }

        if (identifier === DEVATEK || (identifier === SMART && hasSaklama)) {
            return filteredsoftwareList;
        }

        return filteredsoftwareList.filter((software) =>
            software.label.includes("Kolay Defter v.1.0")
        );
    }

    applyWithoutSignature() {
        this.props.history.push("/edefter/eDefterApplicationPetition");
    }

    applyWithSignature() {
        this.setState({
            unsignedApplication: false,
        })
    }

    getEdefterContract() {
        let self = this;
        let selected = deepCopyObject(self.state.selected);
        let params = {
            url: '/signature/contract/getEdefterContract',
            method: "post"
        };

        self.setState({loading: true});

        request(params).then(response => {
            if (response.data && response.data.edefterContract && response.data.customer) {
                let contractToBeSigned = response.data.edefterContract;
                let customer = response.data.customer;
                let sorumluFieldsValid = this.checkContactPersonInfo(customer);
                // selected.startDate = moment(contractToBeSigned.contractStartDate ,'YYYY-MM-DD').add(3, 'hours') ;
                selected.startDate = moment();
                self.setState({
                    selected,
                    customer,
                    sorumluFieldsValid,
                    // edefterApplicationModal: !sorumluFieldsValid ,
                    loading: false,
                    unsignedApplication: this.props.unsignedApplication,
                    loadingUnsignedApplication: false
                });
            } else {
                self.setState({loading: false});
                showAxiosError({message: "Sözleşme Sorgusu Yapılamadı!"});
            }
        }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });
    }

    checkContactPersonInfo(customer) {
        if (!customer) {
            return false;
        } else if ((!customer.sorumluTckn || customer.sorumluTckn && customer.sorumluTckn === "") ||
            (!customer.sorumluAd || customer.sorumluAd && customer.sorumluAd === "") ||
            (!customer.sorumluSoyad || customer.sorumluSoyad && customer.sorumluSoyad === "") ||
            (!customer.sorumluCepTel || customer.sorumluCepTel && customer.sorumluCepTel === "") ||
            (!customer.sorumluEPosta || customer.sorumluEPosta && customer.sorumluEPosta === "")) {
            return false;
        } else {
            return true;
        }
    }

    nextPage() {
        if (this.props.currentUser.contractSignatureRequired) {
            this.props.history.push("/signature/contract");
        } else if (this.props.currentUser.aliasSignatureRequired) {
            this.props.history.push("/signature/alias");
        } else {
            setTimeout(function () {
                window.location.href = SERVLET_PATH + "/";
            }, 100);
        }
    }

    editHandleInputChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        let name = target.name;

        let valid = this.editValidateDef[name] && this.editValidateDef[name](value);
        this.setState((prevState, props) => {
            prevState.selected[name] = value;
            prevState.valid[name] = valid;
            return {
                selected: prevState.selected,
                valid: prevState.valid
            };
        });
    }

    editClassName(name) {
        let valid = this.state.valid[name];

        if (typeof valid !== "boolean")
            return undefined;
        else {
            return {
                valid: valid,
                invalid: !valid
            };
        }
    }

    cancelClicked() {
        this.nextPage();
    }

    cancelClickedWithAlert() {
        Swal({
            title: 'Dikkat!',
            text: 'İptal etmeniz durumunda Hizmet Sözleşmesi sayfasına yönlendirileceksiniz. GİB E-Defter Başvurunuz olmayacaktır.',
            showCancelButton: true,
            confirmButtonText: 'Tamam',
            cancelButtonText: 'Kapat',
        }).then((result) => {
            if (result.value) {
                this.cancelClicked();
            }
        });

    }


    inputClicked() {
        let self = this;
        if (!self.state.sorumluFieldsValid)
            self.setState({edefterApplicationModal: true});
        else
            self.inputOkClicked();
    }

    inputOkClicked() {
        let params = {
            url: '/signature/application/nextEDefterApplication',
            method: "post",
            data: {
                software: this.state.selected.software,
                startDate: this.state.selected.startDate && (this.state.selected.startDate.format("YYYY-MM") + '-01')
            }
        };

        this.setState({
            loading: true
        });

        request(params)
            .then(response => {
                let url;

                if (response.data.value) {
                    let contractArr = new Uint8Array(base64_arraybuffer.decode(response.data.value));
                    let blob = new Blob([contractArr], {type: "application/pdf"});
                    let urlCreator = window.URL || window.webkitURL;
                    url = urlCreator.createObjectURL(blob);
                }

                this.setState({
                    contract: response.data,
                    contractUrl: url
                });
            }).catch(function (error) {
            showAxiosError(error);
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    }

    signCompleted(param) {

        let params = {
            url: '/signature/application/writeSignedEDefterApplication',
            method: "post",
            data: {
                uuid: this.state.contract.uuid,
                value: param.signedDocument,
                software: this.state.selected.software,
                startDate: this.state.selected.startDate && (this.state.selected.startDate.format("YYYY-MM") + '-01'),
                certificateExpireDate: param.certificate && param.certificate.certificate && param.certificate.certificate.expiresOn && moment(param.certificate.certificate.expiresOn).format("YYYY-MM-DD")
            }
        };

        return request(params).catch(function (error) {
            showAxiosError(error);
        });
    }

    onComplete() {
        this.setState({
            loading: false,
            contract: null,
            contractUrl: null,
            initialized: false
        });
        this.nextPage();
    }
    hasSaklamaService() {
        let customerId = this.props.currentUser.customerId;
        let params = {
            url: `/edefter/hasServiceIdFive?customerId=${customerId}`,
            method: `post`
        };
        return request(params)
            .then((response) => {

                this.setState({
                    hasService: response.data
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    renderSoftwareList() {
        return <Row>
            <Col sm={4}>
                Uyumlu Yazılım
            </Col>
            <Col sm={8}>
                <div style={{position: 'relative'}}>
                    <Input name="software" type="select" value={this.state.selected.software}
                           onChange={this.editHandleInputChange} {...this.editClassName("software")}>
                        <option key="" value="">Seçiniz</option>
                        {this.state.softwareList.map(value => {
                            return <option key={value.value} value={value.value}>{value.label}</option>
                        })}
                    </Input>
                    {this.state.softwareListLoading && <ReactLoadingTop style={{width: "15px", height: "15px"}}/>}
                </div>
            </Col>
        </Row>
    }

    isFutureMonth = (date) => {
        /*const endOfYear = moment(date).endOf('year');
        const today = moment().startOf('year');
        const endOfYearNextYear = moment().endOf('year');
        return endOfYear.isBetween(today, endOfYearNextYear, 'day', '[]');*/
        const startOfNextYear = moment().startOf('year');
        const endOfYearNextYear = moment().add(1, 'year').endOf('year');
        return moment(date).isBetween(startOfNextYear, endOfYearNextYear, 'day', '[]');
    };

    renderStartDate() {
        return <Row>
            <Col sm={4}>
                EDefter Uygulamasına Başlangıç Tarihi
            </Col>
            <Col sm={8}>
                <Datetime utc={true} isValidDate={this.isFutureMonth} closeOnSelect={true} dateFormat="YYYY-MM"
                          name="startDate" value={this.state.selected.startDate}
                          onChange={this.editHandleInputChange} {...this.editClassName("startDate")}
                    // inputProps={{disabled: ["eczacikart", "togb", "medikal", "isitmemerkezi", "testud"].includes(VirtualHost.conf.resourcePrefix)}}
                />
            </Col>
        </Row>
    }

    renderInput() {
        return <Container>
            {this.renderSoftwareList()}
            {this.renderStartDate()}
            <Row>
                <Col sm={8}>
                </Col>
                <Col sm={2}>
                    {this.state.unsignedApplication === false &&
                        <Button style={{width: '100%'}}
                                onClick={() => this.cancelClickedWithAlert()}
                                color="secondary">İptal</Button>
                    }
                </Col>
                <Col sm={2}>
                    <Button style={{width: '100%'}} onClick={this.inputClicked} color="primary"
                            disabled={!this.editValidateDef.software(this.state.selected.software) || !this.editValidateDef.startDate(this.state.selected.startDate) || this.state.edefterApplicationModal}>Tamam</Button>
                </Col>
            </Row>
        </Container>
    }

    renderContractExplanation() {
        return this.state.contract && <Alert color="info">
            Aşağıdaki sözleşmenin imzalanması gerekmektedir. Akıllı kartınızı takınız ve sözleşmeyi imzalayınız.
        </Alert>
    }

    renderContract() {
        return this.state.contractUrl && <iframe src={this.state.contractUrl} style={{width: "100%", height: "500px"}}/>
    }

    renderSigner() {
        return this.state.contract &&
            <SingleFileSigner currentUser={this.props.currentUser} pdf={true} document={this.state.contract.value}
                              signCompleted={this.signCompleted} omitXmlDeclaration={true}
                              onComplete={this.onComplete}/>
    }

    render() {
        const {loadingUnsignedApplication} = this.state;
        if (loadingUnsignedApplication) {
            return <div>Yükleniyor...</div>;
        }
        return (
            <div className="row">
                <Notify ref="notify"/>
                {this.state.alert}
                <div className="col-md-12">
                    <div className="card">
                        {
                            this.state.unsignedApplication &&
                            <div className="card-header ">
                                <h4 className="card-title">E-Defter Başvuru Seçeneği</h4>
                            </div>
                        }
                        {
                            !this.state.unsignedApplication &&
                            <div className="card-header ">
                                <h4 className="card-title">GİB E-Defter Başvurusu İmzala</h4>
                            </div>
                        }
                        <div className="card-body">
                            {
                                this.state.unsignedApplication &&
                                <Container>
                                    <Row>
                                        <Col sm={2}>
                                        </Col>
                                        <Col sm={8}>
                                            <p>
                                                GİB EDefter Başvurusunu e-imza kullanmadan yapmak ister misiniz?
                                            </p>
                                        </Col>
                                        <Col sm={2}>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={2}>
                                        </Col>
                                        <Col sm={3}>
                                            <Button style={{width: '100%'}} onClick={this.applyWithoutSignature}
                                                    color="success">İmzasız
                                                Başvur</Button>
                                        </Col>
                                        <Col sm={3}>
                                            <Button style={{width: '100%'}} onClick={this.applyWithSignature}
                                                    color="primary"
                                                    disabled={!this.editValidateDef.software(this.state.selected.software) || !this.editValidateDef.startDate(this.state.selected.startDate) || this.state.edefterApplicationModal}>E-imza
                                                İle Başvur</Button>
                                        </Col>
                                        <Col sm={2}>
                                            <Button style={{width: '100%'}}
                                                    onClick={() => this.cancelClickedWithAlert()}
                                                    color="secondary">İptal</Button>
                                        </Col>
                                        <Col sm={2}>
                                        </Col>
                                    </Row>
                                </Container>
                            }
                            {!this.state.unsignedApplication && !this.state.loading && !this.state.contract && this.renderInput()}
                            {!this.state.loading && this.state.contract && this.renderContractExplanation()}
                            {!this.state.loading && this.state.contract && this.renderContract()}
                            <br/>
                            {!this.state.loading && this.state.contract && this.renderSigner()}
                            {this.state.loading && <ReactLoading type="spinningBubbles" style={{
                                width: "100px",
                                height: "100px",
                                margin: "100px auto 100px auto",
                                fill: "#888"
                            }}/>}
                        </div>
                    </div>
                </div>
                {this.state.edefterApplicationModal &&
                    <EdefterApplicationModal
                        currentUser={this.props.currentUser}
                        edefterApplicationModal={this.state.edefterApplicationModal}
                        close={() => {
                            this.setState({edefterApplicationModal: false});
                            this.inputOkClicked();
                        }}
                        cancel={() => {
                            this.setState({edefterApplicationModal: false});
                            this.cancelClicked();
                        }}
                        customer={this.state.customer}
                        showBody={false}
                    />
                }
            </div>
        );
    }
}

export default ApplicationSigner;
